import axios from 'axios';
import {
    GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST,
    GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST,
} from './action-constants';

const URL_PROGRAMS_ASSIGNED_TO_LOGIN_LIST = 'programs/assignedtologin'
const URL_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST = 'programs/notassignedtologin'

export function getProgramsAssignedToLoginList (loginid) {
    const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + URL_PROGRAMS_ASSIGNED_TO_LOGIN_LIST + '/' + loginid
    return {
      type: GET_PROGRAMS_ASSIGNED_TO_LOGIN_LIST,
      payload: new Promise((resolve, reject) => {
        axios
          .get(JSONURL)
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    }
}

export function getProgramsNOTAssignedToLoginList (loginid) {
    const JSONURL = process.env.REACT_APP_DATABASE_URL + '/' + URL_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST + '/' + loginid
    return {
      type: GET_PROGRAMS_NOT_ASSIGNED_TO_LOGIN_LIST,
      payload: new Promise((resolve, reject) => {
        axios
          .get(JSONURL)
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    }
}
